module.exports = __webpack_public_path__ + "img/realname_1.898b7e54.png";